module.exports = __webpack_public_path__ + "static/media/Lifestyle.2b3c021b.jpg";